import { useTranslation } from 'react-i18next';

interface LogoutConfirmModalProps {
  open: boolean;
  isSigningOut: boolean;
  error: string | null;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function LogoutConfirmModal({
  open,
  isSigningOut,
  error,
  onCancel,
  onConfirm,
}: LogoutConfirmModalProps) {
  const { t } = useTranslation();

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[11000] flex items-center justify-center px-6">
      <div
        className="absolute inset-0 bg-black/50"
        onClick={isSigningOut ? undefined : onCancel}
        aria-hidden="true"
      />
      <div
        className="relative bg-white rounded-2xl w-full max-w-xs overflow-hidden"
        role="dialog"
        aria-modal="true"
        aria-labelledby="logout-modal-title"
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="px-6 pt-6 pb-5 text-center">
          <div className="w-12 h-12 rounded-full bg-[#FEF2F2] flex items-center justify-center mx-auto mb-4">
            <i className="ri-logout-box-r-line text-[#EF4444] text-xl"></i>
          </div>
          <h3 id="logout-modal-title" className="text-[#1A1A1A] text-base font-bold mb-1">
            {t('logout.signOut')}
          </h3>
          <p className="text-[#9CA3AF] text-sm">{t('logout.signOutDesc')}</p>
          {error && (
            <p className="mt-3 text-[#EF4444] text-xs font-medium" role="alert">
              {error}
            </p>
          )}
        </div>
        <div className="flex border-t border-gray-100">
          <button
            type="button"
            disabled={isSigningOut}
            onClick={onCancel}
            className="flex-1 py-3.5 text-[#374151] text-sm font-medium cursor-pointer hover:bg-gray-50 transition-colors border-r border-gray-100 whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {t('logout.cancel')}
          </button>
          <button
            type="button"
            disabled={isSigningOut}
            onClick={() => void onConfirm()}
            className="flex-1 py-3.5 text-[#EF4444] text-sm font-bold cursor-pointer hover:bg-[#FEF2F2] transition-colors whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-1.5"
          >
            {isSigningOut && <i className="ri-loader-4-line animate-spin text-sm"></i>}
            {t('logout.signOutBtn')}
          </button>
        </div>
      </div>
    </div>
  );
}
